import { useState } from "react";
import * as am5 from '@amcharts/amcharts5';
import DonutChart from "@components/DonutChart/DonutChart";
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import FactoryOutlinedIcon from '@mui/icons-material/FactoryOutlined';
import LocalAtmOutlinedIcon from '@mui/icons-material/LocalAtmOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { ArrowCircleDown } from "@mui/icons-material";
import Button from "@components/Button";

import LoaderImage from "@assets/loader.gif";

import { transformToCamelCase } from "@helpers/utils";
import "./OccupationDetailsCard.scss";

const OccupationDetailsCard = ({ isLoadingOccupationCard, isLoadingDownloadISCOCard, data, className, handleDownloadISCOPDF, additionalTitle = "" }: any) => {
    const [isMonthlySalary, setIsMonthlySalary] = useState<boolean>(true); 

    return (
        <>
            <div className={"occupation-card-details " + className} style={{ height: isLoadingOccupationCard ? '100%' : 'auto' }}>
                {isLoadingOccupationCard ?
                    <div className="main-loader">
                        <img
                            src={LoaderImage}
                            alt="Loader giff"
                            style={{ width: 60 }}
                        />
                    </div>
                    :
                    <>
                        {data ?
                            <>
                                {data &&
                                    <>
                                        <div>
                                            {data.isco4_label &&
                                                <div className="isco-label">
                                                    {transformToCamelCase(data.isco4_label)} {additionalTitle ? " " + additionalTitle : ""}
                                                </div>
                                            }
                                            <div className="download-container">
                                                {isLoadingDownloadISCOCard ?
                                                    <div className="download-loader">
                                                        <img
                                                            src={LoaderImage}
                                                            alt="Loader giff"
                                                        />
                                                    </div>
                                                    :
                                                    <ArrowCircleDown type="button" className="float-end" onClick={handleDownloadISCOPDF} />
                                                }
                                            </div>
                                        </div>
                                        {data.isco4_label &&
                                            <>
                                                <div className="job-description">
                                                    <BusinessCenterOutlinedIcon className="icon" />
                                                    Job Description
                                                </div>
                                                <div className="job-description-value">
                                                    {data.isco4_description}
                                                </div>
                                            </>
                                        }
                                        {(data.total_jobs || data.experience_range) &&
                                            <div className="total-job-experience-container">
                                                {data.total_jobs &&
                                                    <div className="total-job-container">
                                                        <div className="total-job-value">
                                                            {data.total_jobs}
                                                        </div>
                                                        <div className="total-job-label">{transformToCamelCase(data.isco4_label)} job posts</div>
                                                    </div>
                                                }
                                                {data.experience_range &&
                                                    <div className="experience-container">
                                                        <div className="experience-value">
                                                            {data.experience_range} years
                                                        </div>
                                                        <div className="experience-label">Typical years of experience listed in job posts</div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {data.education_levels && data.specializations &&
                                            <div className="specializations-container">
                                                {data.education_levels && data.education_levels.length > 0 &&
                                                    <div>
                                                        <div className="education-level-container">
                                                            <SchoolOutlinedIcon className="icon" />
                                                            Education Levels
                                                        </div>
                                                        <DonutChart name="educationLevels" categoryFieldName="education_level_name" valueFieldName="education_level_percentage" data={data.education_levels} colors={[{ categoryName: "Master", color: am5.color(0x1d506b) }, { categoryName: "Doctorate", color: am5.color(0xb4c5ce) }, { categoryName: "Bachelor", color: am5.color(0x022437) }, { categoryName: "Diploma", color: am5.color(0x829ead) }]} />
                                                    </div>
                                                }
                                                {data.specializations && data.specializations.length > 0 &&
                                                    <div>
                                                        <div className="fields-education-container">
                                                            <FactoryOutlinedIcon className="icon" />
                                                            Fields of Education
                                                        </div>
                                                        <ul className="education-level-list">
                                                            {data.specializations?.map((specialization: any, index: number) => {
                                                                return <li key={"specialization-" + index}>{specialization}</li>
                                                            })}
                                                        </ul>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {data.summary_monthly_salaries &&
                                            <>
                                                {(data.summary_monthly_salaries.minimum_salary ||
                                                    data.summary_monthly_salaries.average_salary ||
                                                    data.summary_monthly_salaries.maximum_salary) &&
                                                    <>
                                                        <div className="salaries-title-container">
                                                            <LocalAtmOutlinedIcon className="icon" />
                                                            Salary Brackets
                                                            <Button label={"MONTHLY"} onClick={() => setIsMonthlySalary(true)} className={"salaries-title-container-button " + (isMonthlySalary ? " active " : "")} />
                                                            <Button label={"YEARLY"} onClick={() => setIsMonthlySalary(false)} className={"salaries-title-container-button " + (isMonthlySalary ? " " : " active ")} />
                                                        </div>
                                                        <div className="salaries-container">
                                                            {data.summary_monthly_salaries.minimum_salary &&
                                                                <div className="salary-container" >
                                                                    <div className="salary-value" >
                                                                        <span className="salary-value-span">
                                                                            ${isMonthlySalary ? data.summary_monthly_salaries.minimum_salary?.toLocaleString() : (data.summary_monthly_salaries.minimum_salary * 12)?.toLocaleString()}
                                                                        </span>
                                                                        <span className="salary-value-period">&nbsp;/ {isMonthlySalary ? "Month" : "Year"}</span>
                                                                    </div>
                                                                    <div className="salary-value-title">Low Qualifications/Experience</div>
                                                                </div>
                                                            }
                                                            {data.summary_monthly_salaries.average_salary &&
                                                                <div className="salary-container" >
                                                                    <div className="salary-value" >
                                                                        <span className="salary-value-span">
                                                                            ${isMonthlySalary ? data.summary_monthly_salaries.average_salary?.toLocaleString() : (data.summary_monthly_salaries.average_salary * 12)?.toLocaleString()}
                                                                        </span>
                                                                        <span className="salary-value-period">&nbsp;/ {isMonthlySalary ? "Month" : "Year"}</span>
                                                                    </div>
                                                                    <div className="salary-value-title">Mid Qualifications/Experience</div>
                                                                </div>
                                                            }
                                                            {data.summary_monthly_salaries.maximum_salary &&
                                                                <div className="salary-container" >
                                                                    <div className="salary-value" >
                                                                        <span className="salary-value-span">
                                                                            ${isMonthlySalary ? data.summary_monthly_salaries.maximum_salary?.toLocaleString() : (data.summary_monthly_salaries.maximum_salary * 12)?.toLocaleString()}
                                                                        </span>
                                                                        <span className="salary-value-period">&nbsp;/ {isMonthlySalary ? "Month" : "Year"}</span>
                                                                    </div>
                                                                    <div className="salary-value-title">High Qualifications/Experience</div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </>
                                                }

                                            </>
                                        }
                                    </>
                                }
                                {data.skills &&
                                    <div className="skills-container">
                                        {data.skills.length > 0 &&
                                            <>
                                                <div className="skills-container-title">
                                                    Skills in Demand
                                                </div>
                                                <ul className="skills-ul">
                                                    <>
                                                        {data.skills?.map((skill: any, index: number) => {
                                                            return <li key={"skill-" + index}>
                                                                <span />
                                                                {transformToCamelCase(skill)}
                                                            </li>
                                                        })}
                                                    </>
                                                </ul>
                                            </>
                                        }
                                    </div>
                                }
                                {data.job_demand_ai_impact_label &&
                                    <div className="fields-job-demand-ai-impact-container">
                                        <div className="fields-job-demand-ai-impact-title-container">
                                            {data.job_demand_ai_impact_label === "Growing" && <TrendingUpIcon className="icon" />}
                                            {data.job_demand_ai_impact_label === "Stable" && <TrendingFlatIcon className="icon" />}
                                            {data.job_demand_ai_impact_label === "Shrinking" && <TrendingDownIcon className="icon" />}
                                            <span className="fields-job-demand-ai-impact-title">{data.job_demand_ai_impact_label} Job</span>
                                        </div>
                                        <ul>
                                            {data.creation_impact_reasoning && 
                                                <li>
                                                    <div className="fields-job-demand-ai-impact-category-title">Creation Impact</div>
                                                    <div className="fields-job-demand-ai-impact-category-reasoning">{data.creation_impact_reasoning}</div>
                                                </li>    
                                            }
                                            {data.productivity_impact_reasoning &&
                                                <li>
                                                    <div className="fields-job-demand-ai-impact-category-title">Productivity Impact</div>
                                                    <div className="fields-job-demand-ai-impact-category-reasoning">{data.productivity_impact_reasoning}</div>
                                                </li>
                                            }
                                            {data.security_impact_reasoning &&
                                                <li>
                                                    <div className="fields-job-demand-ai-impact-category-title">Security Impact</div>
                                                    <div className="fields-job-demand-ai-impact-category-reasoning">{data.security_impact_reasoning}</div>
                                                </li>
                                            }
                                            {data.wage_impact_reasoning &&
                                                <li>
                                                    <div className="fields-job-demand-ai-impact-category-title">Wage Impact</div>
                                                    <div className="fields-job-demand-ai-impact-category-reasoning">{data.wage_impact_reasoning}</div>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                }
                            </>
                            :
                            <div>N/A</div>
                        }
                    </>
                }
            </div>
        </>
    );
}

export default OccupationDetailsCard;